<template>
  <div class="tab-container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <template v-for="(item, index) in tabMapOptions">
        <el-tab-pane
          :key="item.id"
          :label="item.groupName"
          :name="item.id"
        >
          <span slot="label">
            {{item.groupName}}
            <span>({{item.count || 0}})</span>
            <el-dropdown v-show="type=='project'?index>4:index>5">
              <i class="iconfont icon-edit edit-icon" />
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="renameChange(item)">重命名</el-dropdown-item>
                <el-dropdown-item @click.native="delChange(item)">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </el-tab-pane>
      </template>
    </el-tabs>
    <!-- 删除弹框 -->
    <div>
      <Dialogs
        :dialogs="dialog"
        @dialogVisible="beforeClose"
        width="50%"
      >
        <template #desc>
          <div class="subbox">
            <div style="width:394px;margin-left:40px">该分组删除之后将无法恢复，确认删除？</div>
          </div>
        </template>
      </Dialogs>
    </div>
    <!-- 重命名弹框 -->
    <div>
      <Dialogs :dialogs="dialog1" @dialogVisible="beforeClose">
        <template #desc>
          <div class="subbox">
            <div style="width: 100px" />
            <el-input v-model="dialog1.groupName" placeholder="请输入新的分组名称" />
          </div>
        </template>
      </Dialogs>
    </div>
  </div>
</template>

<script>
import Dialogs from './dialog.vue'
import { updateProGroupName, delProGroup } from '../../utils/api/project'
import { delTaskGroup, updateTaskGroupName } from '../../utils/api/task'
export default {
  name: 'Tab',
  // eslint-disable-next-line vue/no-unused-components
  components: { Dialogs },
  props: {
    tabMapOptions: {
      type: Array,
      default: () => {
        return []
      }
    },
    active: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeName: '',
      // 删除弹框
      dialog: {
        addDounced: false, // 显示新增
        title: '删除分组',
        width: '492px',
        id: '',
        slotName: 'desc',
        // 操作按钮
        operatorList: [
          { label: '取消', type: '', fun: this.cancelDialog },
          { label: '确定', type: 'danger', fun: this.submitDialog }
        ]
      },
      // 重命名弹框
      dialog1: {
        addDounced: false, // 显示新增
        title: '重命名分组名称',
        width: '30%',
        slotName: 'desc',
        id: '',
        groupName: '',
        // 操作按钮
        operatorList: [
          { label: '取消', type: '', fun: this.cancelDialog },
          { label: '确定', type: 'primary', fun: this.submitDialog1 }
        ]
      }
    }
  },
  watch: {
    tabMapOptions: {
      handler() {
        this.activeName = this.active || this.tabMapOptions[0].id
      }
    }
  },
  mounted() {
  },
  methods: {
    // 标签分组
    handleClick(tab, event) {
      this.activeName = tab.paneName
      this.$emit('tabs', tab, this.tabMapOptions)
    },
    // 关闭前的回调(弹框)
    beforeClose(val) {
      this.dialog.addDounced = val.addDounced
      this.dialog1.addDounced = val.addDounced
    },
    // 删除
    delChange(date) {
      this.dialog.addDounced = true
      this.dialog.id = date.id
    },
    // 删除弹框确定
    submitDialog() {
      var date = {
        id: this.dialog.id
      }
      if (this.type === 'project') {
        delProGroup(date).then((data) => {
          if (data.code === 10000) {
            // this.$message.success('项目分组删除成功！')
            this.activeName = 'allPro'
            this.$emit('tabsEvent', this.activeName)
            this.dialog.addDounced = false
          }
        }).catch((error) => {
          console.log(error)
        })
      } else if (this.type === 'task') {
        delTaskGroup(date).then((data) => {
          if (data.code === 10000) {
            // this.$message.success('任务分组删除成功！')
            this.activeName = 'todoTask'
            this.$emit('tabsEvent', this.activeName)
            this.dialog.addDounced = false
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    // 重命名
    renameChange(date) {
      this.dialog1.addDounced = true
      this.dialog1.groupName = date.groupName
      this.dialog1.id = date.id
    },
    // 重命名弹框确定
    submitDialog1() {
      var date = {
        id: this.dialog1.id,
        groupName: this.dialog1.groupName
      }
      if (this.type === 'project') {
        updateProGroupName(date).then((data) => {
          if (data.code === 10000) {
            // this.$message.success('项目分组重命名成功！')
            this.$emit('tabsEvent', this.activeName)
            this.dialog1.addDounced = false
          }
        }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
        })
      } else if (this.type === 'task') {
        updateTaskGroupName(date).then((data) => {
          if (data.code === 10000) {
            // this.$message.success('任务分组重命名成功！')
            this.$emit('tabsEvent', this.activeName)
            this.dialog1.addDounced = false
          }
        }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
        })
      }
    },
    // 弹框取消
    cancelDialog() {
      this.dialog.addDounced = false
      this.dialog1.addDounced = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/index.scss';
.edit-icon{
  font-size: 15px;
  color: #c7c7c7;
  display: none;
}
.subbox {
  margin:  0 14px !important;
}
.type_boxs {
  display: flex;
  align-items: center;
}
.type_box {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 12px;
}
.card_img {
  width: 100%;
  vertical-align: middle;
}
#card_icon {
  width: 40px;
  height: 34px;
  border-radius: 4px 0px 0px 4px;
  border: 1px solid #C7C7C7;
  text-align: center;
  line-height: 34px;
  color: $color_6;
  font-size: 25px;
  cursor: pointer;
}
#card_icon_ {
  width: 40px;
  height: 34px;
  border-radius: 4px 0px 0px 4px;
  background: $color_main;
  border: 1px solid $color_main;
  text-align: center;
  line-height: 34px;
  color: $color_white;
  font-size: 25px;
  cursor: pointer;
}
#list_icon {
  width: 40px;
  height: 34px;
  border: 1px solid #C7C7C7;
  border-radius: 0px 4px 4px 0px;
  text-align: center;
  line-height: 34px;
  color: $color_6;
  font-size: 23px;
  margin-right: 40px;
  cursor: pointer;
}
#list_icon_ {
  width: 40px;
  height: 34px;
  background: $color_main;
  border: 1px solid $color_main;
  border-radius: 0px 4px 4px 0px;
  text-align: center;
  line-height: 34px;
  color: $color_white;
  font-size: 23px;
  margin-right: 40px;
  cursor: pointer;
}
.card_list {
  width: 100%;
  cursor: pointer;
  margin-bottom: 35px;
}
.card_marker {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
}
.card_marker:hover .card_img_marker {
  display: block;
}
.card_progress {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #E9E9EA;
}
.card_progress_color {
  width: 60%;
  height: 2px;
  background: #2DB039;
}
.card_img_marker {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.24);
  display: none;
}
.set_icon {
  font-size: 13px;
  color: $color_white;
  display: block !important;
}
.card_img_marker_icon {
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  position: absolute;
  bottom: 10px;
  right: 7px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
}
.card_content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 6px 0;
}
.card_text {
  display: flex;
  align-items: center;
  font-size: $font_14;
  font-family: $font_family;
  font-weight: 400;
  color: $color_3;
  line-height: 20px;
}
.drawer_icon {
  font-size: $font_14;
  color: $color_6;
  margin-left: 8px;
  display: block !important;
}
.cover_box {
  width: 832px;
  background: $color_white;
  border-radius: 8px;
  border: 1px solid #E2E2E2;
  margin: auto;
  display: flex;
}
.cover_left {
  width: 375px;
  padding: 20px;
  height: 510px;
  border-right: 1px solid #E2E2E2;
}
.cover_title {
  font-size: $font_14;
  font-family: $font_family;
  font-weight: 400;
  color: $color_3;
  line-height: 20px;
}
.cover_list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 7px;
  margin-left: -3px;
}
.cover_img {
  width: 162px;
  height: 90px;
  border-radius: 10px;
  margin-left: 23px;
  margin-top: 24px;
}
.cover_right {
  width: 375px;
  padding: 20px;
}
.cover_select {
  display: flex;
  align-items: flex-start;
  margin-top: 31px;
  color: $color_3;
}
.cover_text {
  color: $color_9;
  margin-top: 6px;
}
.cover_boxs {
  margin: 0 14px;
}
.info_subject {
  display: flex;
  align-items: baseline;
  font-size: $font_14;
  font-family: $font_family;
  font-weight: 400;
  color: $color_6;
  line-height: 22px;
  border-bottom: 1px solid #E9E9EA;
  margin-bottom: 18px;
}
.info_subject::before {
  content: '*';
  color: #FF4D42;
}
.info_subject ::v-deep .el-textarea__inner {
  padding: 5px 10px;
  border: none;
}
.info_personnel_surname0 {
  width: 25px;
  height: 25px;
  font-size: $font_14;
  font-family: $font_family;
  font-weight: 400;
  color: $color_white;
  line-height: 25px;
  text-align: center;
  color: $color_white;
  background: $color_main;
  border-radius: 50%;
}
.copy_conyent {
  margin: 5px 42px 10px 47px;
}
.copy_label {
  font-size: $font_16;
  font-family: $font_family;
  font-weight: 500;
  color: $color_3;
  margin-bottom: 10px;
}
.copy_value {
  width: calc(100% - 32px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  margin-left: 32px;
}
.copy_tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .copy_tags_box {
    position: relative;
    cursor: pointer;
    .del_icon {
      font-size: 13px;
      color: $color_9;
      position: absolute;
      top: -5px;
      right: -6px;
      display: none;
    }
    .del_icon:hover {
      color: $color_main;
    }
  }
  .add_icon {
    font-size: $font_18;
    color: $color_9;
    margin: 0 24px;
    cursor: pointer;
  }
  .add_icon:hover {
    color: $color_main;
  }
}
.copy_tags:hover .del_icon {
  display: block;
}
.copy_checked {
  font-size: $font_14;
  font-family: $font_family;
  font-weight: 400;
  color: $color_3;
}
.archive_content {
  margin: 5px 12px 0 12px;
  font-size: $font_14;
  font-family: $font_family;
  font-weight: 400;
  color: $color_3;
  line-height: 24px;
  text-indent: 28px;
}
.create_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.create_key {
  width: 100px;
  display: flex;
  align-items: center;
}
.create_value {
  width: calc(100% - 100px);
}
.create_icon {
  color: $color_9;}
</style>

